import { createSelector } from '@reduxjs/toolkit';
import { fetchEditors, fetchEditorsFake } from './editorsCreators';

const shouldFetchEditorsNow = createSelector(
    [(state) => state.user.connectSession, (state) => state.user.isAdmin, (state) => state.editors.shouldUpdate],
    (connectSession, isAdmin, shouldUpdate) => connectSession && isAdmin && shouldUpdate
);

const shouldFetchEditorsFake = createSelector(
    [
        (state) => state.user.protectSession,
        (state) => state.user.connectSession,
        (state) => state.user.isAdmin,
        (state) => state.editors.shouldUpdate,
    ],
    (protectSession, connectSession, isAdmin, shouldUpdate) =>
        protectSession && !connectSession && isAdmin && shouldUpdate
);

export const refreshEditors = createSelector(
    [shouldFetchEditorsNow, shouldFetchEditorsFake],
    (shouldFetch, shouldFetchFake) => {
        if (shouldFetch) {
            return fetchEditors();
        }
        if (shouldFetchFake) {
            return fetchEditorsFake();
        }
    }
);
